import LocationEAP from './LocationEAP';
export default LocationEAP;
